{
  "de": {
    "upsell": {
      "categories": {
        "category": "Kategorie",
        "home_automation": "Hausautomation",
        "integration": "Integration",
        "interior_decoration": "Inneneinrichtung",
        "interior_doors": "Innentüren",
        "kitchen": "Küche",
        "marketing": "Marketing",
        "real_estate_agent": "Immobilienmakler",
        "telecom": "Telekommunikation",
        "wood_finishing": "Holzveredelung"
      },
      "contact_us": "Interessiert? Kontaktieren Sie uns!",
      "decisions_partners": {
        "guidance": "Entscheidungspartner können Angebote erstellen und/oder verwalten, sofern ihnen die Berechtigung erteilt wurde.",
        "intercom": "Hallo Ziggu! Ich interessiere mich für die Funktion Entscheidungspartner. Können Sie mir weitere Informationen geben? Mit freundlichen Grüßen, %{name}"
      },
      "decisions_proposals_multiple_approval": {
        "cta": "Chatten Sie mit uns, um mehr zu erfahren",
        "description": "Genug davon, die Genehmigung eines Angebots aufzuheben, um Änderungen vorzunehmen und wieder von vorne zu beginnen? Mehrere Genehmigungen sollten Sie nicht ausbremsen.",
        "description_2": "Lassen Sie Ihre Kunden mehrere Angebote innerhalb derselben Entscheidung genehmigen. Sie müssen kein bestehendes Angebot zurückziehen oder eine neue Entscheidung starten.",
        "description_3": "Weniger Aufwand und mehr Zeit für das, was wirklich zählt: Ihren Kunden!",
        "intercom": "Hallo Ziggu! Ich möchte, dass der Kunde mehrere Angebote innerhalb einer Entscheidung genehmigen kann. Können Sie mir weitere Informationen geben? Mit freundlichen Grüßen, %{name}",
        "premium_add_on": "Premium-Erweiterung",
        "title": "Sparen Sie Zeit mit der flexiblen Angebots-Erweiterung!"
      },
      "decisions_reminders": {
        "guidance": "Mit Erinnerungen können Sie Kunden automatisch benachrichtigen, dass Angebote auf eine Entscheidung warten.",
        "intercom": "Hallo Ziggu! Ich interessiere mich für die Funktion Erinnerungen. Können Sie mir weitere Informationen geben? Mit freundlichen Grüßen, %{name}"
      },
      "financials": {
        "guidance": "Erstellen Sie Zahlungspläne direkt aus genehmigten Angeboten und teilen Sie diese über das Kundenportal mit Ihren Kunden.<br>Halten Sie Ihre Finanzkommunikation transparent und professionell, damit Kunden stets einen klaren Überblick haben, was fällig ist und wann.",
        "intercom": "Hallo Ziggu! Ich interessiere mich für die Finanzen-Funktion für Raten bei Entscheidungen. Können Sie mir weitere Informationen geben? Mit freundlichen Grüßen, %{name}"
      },
      "imInterested": "Ich habe Interesse!",
      "intercom": "Hallo Ziggu! Ich möchte gerne mehr über {upsell} erfahren. Können Sie mir weitere Informationen geben? Mit freundlichen Grüßen, %{name}",
      "interestedToBeListed": "Interesse, hier gelistet zu werden",
      "lookingfor": "Wonach suchen Sie? Z. B. 3D-Visualisierungen, Küche, Telekommunikation",
      "multilingual": {
        "announcements_body": "Neuigkeiten können Sie bereits in {languages} übersetzen. Überall sonst schreiben Sie mit der Multilingual-Funktion einmal, und jeder Kunde liest den Text in seiner eigenen Sprache.",
        "bar_covered": "Sie veröffentlichen bereits auf {language}",
        "bar_uncovered": "Sie veröffentlichen noch nicht auf {language}",
        "body": "Heute erhalten alle dieselbe Version. Mit der Multilingual-Funktion liest jeder Kunde diesen Inhalt in der Sprache, die er selbst eingestellt hat.",
        "chip_tooltip": "{customers} Kunde hat {language} als Sprache | {customers} Kunden haben {language} als Sprache",
        "cta": "Mehr Infos anfragen",
        "cta_expand": "Details anzeigen",
        "cta_sent": "Wir melden uns",
        "customers_count": "1 Kunde | {count} Kunden",
        "error_intercom": "Ihre Frage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
        "headline": "Ihr {count} Kunde {scope} spricht {languages} | Ihre {count} Kunden {scope} sprechen {languages}",
        "headline_single": "Ihr {count} Kunde {scope} spricht {language}. | Alle {count} Kunden {scope} sprechen {language}.",
        "intercom": "Ich möchte mehr über die Multilingual-Funktion erfahren",
        "languages_count": "1 Sprache | {count} Sprachen",
        "languages_other_count": "1 weitere Sprache | {count} weitere Sprachen",
        "missing_add": "Hinzufügen",
        "missing_added": "{language} gehört jetzt zu Ihren Organisationssprachen",
        "missing_hint": "Was Sie hinzufügen, steht überall als Übersetzungssprache zur Verfügung, für Ihre gesamte Organisation.",
        "missing_hint_announcements_only": "Was Sie hinzufügen, wird zur Übersetzungssprache für Ihre gesamte Organisation. Heute nutzen Sie sie für Neuigkeiten; die Multilingual-Funktion öffnet sie überall sonst.",
        "missing_no_permission": "Das Hinzufügen von Organisationssprachen erfordert die Rolle „Inhaber“.",
        "missing_settings_link": "Alle Sprachen in den Organisationseinstellungen verwalten",
        "missing_title": "{count} Kunde {scope} spricht {languages} | {count} Kunden {scope} sprechen {languages}",
        "plan": "Enterprise",
        "scope_project": "in diesem Projekt",
        "scope_selection": "in dieser Auswahl"
      },
      "not_included": "Interesse an dieser Funktion?",
      "project_email_forwarding": {
        "cta": "E-Mails an {project_name} weiterleiten",
        "description": "Ermöglichen Sie allen in Ihrem Team, E-Mails direkt an Ihre Ziggu-Projekte weiterzuleiten.",
        "intercom": "Hallo Ziggu! Ich interessiere mich für die Funktion Projekt-E-Mail-Weiterleitung. Können Sie mir weitere Informationen geben? Mit freundlichen Grüßen, %{name}",
        "marketplace": {
          "title": "Projekt-E-Mail-Weiterleitung",
          "title_sub": "E-Mails direkt an Ihre Ziggu-Projekte weiterleiten."
        },
        "title": "Neu! E-Mail-Weiterleitung innerhalb von Projekten",
        "youtube_id": "vLQtH9GzAXc"
      },
      "project_experience": {
        "contactme": "Ja, Sie können mich diesbezüglich kontaktieren!",
        "cta": "Ihr Projekt-Branding verbessern?",
        "description": "Personalisierte Projekt-URL und Anmeldebildschirm <br/> Eigene Projektumgebung nach der Anmeldung <br/> E-Mails im Projekt-Branding <br/> Erleichtert die Zusammenarbeit mit anderen Bauträgern am selben Projekt",
        "intercom": "Hallo Ziggu! Ich interessiere mich für das Modul Project Experience. Können Sie mir weitere Informationen geben? Mit freundlichen Grüßen, %{name}",
        "marketplace": {
          "title": "Project Experience",
          "title_sub": "Verbessern Sie Ihr Projekt-Branding mit einer personalisierten Projekt-URL und -umgebung"
        },
        "title": "Lassen Sie Ihre Kunden sich mit der neuen Project Experience zu Hause fühlen!",
        "youtube_id": "f26cNo2rwWE"
      },
      "project_templates": {
        "cta": "Aus einer Vorlage importieren?",
        "cta2": "Diese Vorlage in Ihre Projekte importieren? Klicken Sie hier, um diese Funktion freizuschalten!",
        "description": "<p>Transformieren Sie die Art, wie Sie Projekte verwalten, mit vorgefertigten Vorlagen, die Ihnen Zeit sparen und Ihr Team synchron halten.</p><br>\n<p><strong>Vorteile von Vorlagen:</strong></p>\n<ul>\n    <li><strong>- Sparen Sie Stunden</strong> bei wiederkehrenden Aufgaben—importieren Sie ganze Projektstrukturen in Sekunden.</li>\n    <li><strong>- Verbesserte Standardisierung</strong>, da alles an einem Ort ist, von Aufgaben bis zu Dokumenten.</li>\n    <li><strong>- Steigern Sie die Effizienz</strong>, indem Sie Routineprozesse automatisieren, damit Sie sich auf das Wesentliche konzentrieren können.</li>\n</ul>\n<br/><strong>Führen Sie noch heute ein Upgrade durch und erledigen Sie mehr mit weniger Aufwand!</strong>",
        "intercom": "Hallo Ziggu! Ich interessiere mich für die Vorlagen-Funktion. Können Sie mir weitere Informationen geben? Mit freundlichen Grüßen, %{name}",
        "marketplace": {
          "title": "Vorlagen",
          "title_sub": "Transformieren Sie die Art, wie Sie Projekte verwalten, mit vorgefertigten Vorlagen, die Ihnen Zeit sparen und Ihr Team synchron halten."
        },
        "title": "Arbeiten Sie intelligenter mit Vorlagen!"
      },
      "proposal_choice_lists": {
        "guidance": "Mit Optionslisten können Sie Kunden Optionen innerhalb von Angeboten auswählen lassen.",
        "intercom": "Hallo Ziggu! Ich interessiere mich für die Funktion Optionslisten. Können Sie mir weitere Informationen geben? Mit freundlichen Grüßen, %{name}"
      },
      "signatures": {
        "cta_text": "Unterschriften für Ihre Dokumente benötigt? Kontaktieren Sie uns",
        "guidance": "Mit Unterschriften können Sie Kunden wichtige Dokumente digital unterschreiben lassen.",
        "intercom": "Hallo Ziggu! Ich interessiere mich für die Funktion Unterschriften. Können Sie mir weitere Informationen geben? Mit freundlichen Grüßen, %{name}"
      },
      "workflows": {
        "attach_body": "Tipp: Auch Entscheidungen und Umfragen lassen sich an eine Phase hängen. Sie werden dann automatisch veröffentlicht, sobald die Phase erreicht ist.",
        "cta": "Mehr erfahren",
        "cta_sent": "Wir melden uns",
        "dismiss": "Nicht jetzt",
        "intercom": "Ich möchte mehr darüber erfahren, was Workflows zu den Phasen hinzufügen.",
        "move_hint_phases": "Tipp: Eine Phase kann ihre Entscheidungen, Umfragen und Aufgaben selbst veröffentlichen, sobald sie erreicht ist.",
        "move_hint_tasks": "Tipp: Eine Phase kann auch ihre Entscheidungen und Umfragen selbst veröffentlichen, sobald sie erreicht ist."
      },
      "workflows_elements": {
        "guidance": "Ihr aktuelles Paket enthält diesen Elementtyp nicht. Er bleibt in der Phase, aber Kunden erhalten ihn erst nach einem Upgrade.",
        "intercom": "Hallo Ziggu! Ich interessiere mich dafür, Entscheidungen, Umfragen und Aufgaben über Phasen zu teilen. Können Sie mir weitere Informationen geben? Mit freundlichen Grüßen, %{name}"
      }
    }
  }
}
